function InfoIcon({ text }) {
  return (
    <div className='cpt-freebet-popup-info-title-container'>
      <div className='cpt-freebet-popup-info-icon-container'>
        <i className='icon-info' />
      </div>
      <div className='cpt-freebet-popup-info-title-bg'>
        <p className='cpt-freebet-popup-info-title'>{text}</p>
      </div>
    </div>
  );
}

export default InfoIcon;
